
import 'element-ui/lib/theme-chalk/time-picker.css';
import 'element-ui/lib/theme-chalk/icon.css';
import jsonp from "@/assets/js/http";


import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class orderList extends Vue {
    @Prop() isInvitationCode!: any;
    @Prop() baseld!: any;
    isShow: Boolean = true
    isShowCode: Boolean = true
    isInput: Boolean = false
    api: any = {
        addCodeItem: "https://opc" + this.domain + "/ule-live-amdin//api/v1/room/inviteCode/generateInviteCode", // 新增定制码
        getCustomizedCode: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/inviteCode/getInvateCodeList", // 查询定制码列表
        customizedCodeDelate: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/inviteCode/saveInviteCode", // 定制码删除
        modifyInviteCode: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/inviteCode/saveInviteCode", // 修改通用码
        modifyInviteCodeRemarks: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/inviteCode/saveInviteCode", // 修改通用码备注信息
    }
    customInviteCodeList: any
    commonInviteCodeList: any = {
        inviteCode: '',
        limitNumber: ''
    }
    commonUseNum:Number = 0
    customUnUseNum:Number = 0  // 定制码未使用数量
    customUseNum:Number = 0   // 定制码使用数量
    generatedCode:Number = 0  // 定制码已生成
    @Watch('isShow')
    onChange(val: any) {
        if (!val) {
            this.$emit('hintChange', { name: 'isInvitationCode', val: val })
        }
    }
    mounted() {
        this.getCustomizedCode()
    }
    refreshCustomizedCode() {
        this.getCustomizedCode()
        this.$toast('已更新')
    }
    updateCode(){
        this.getCustomizedCode()
        this.$toast('已更新')
    }
    getCustomizedCode() {
        this.fetch({
            url: `${this.api.getCustomizedCode}?baseId=${this.$route.params.id}&sceneId=${this.baseld}`,
            data: {},
            method: "GET",
        }).then((res: any) => {
            this.commonUseNum = res.commonUseNum
            this.customUnUseNum = res.customUnUseNum // 定制码未使用数量
            this.customUseNum = res.customUseNum   // 定制码使用数量
            this.generatedCode = res.customUseNum + res.customUnUseNum   // 定制码已生成
            res.customInviteCode.forEach((item: any) => {
                item['isInput'] = true
            })
            this.customInviteCodeList = res.customInviteCode
            this.commonInviteCodeList = res.commonInviteCode
            this.$forceUpdate()
        })
    }
    modifyInviteCode() {
        this.fetch({
            url: `${this.api.modifyInviteCode}?id=${this.commonInviteCodeList.id}&baseId=${this.$route.params.id}&sceneId=${this.baseld}&limitNumber=${this.commonInviteCodeList.limitNumber}`,
            method: "POST",
        }).then((res: any) => {
            this.$toast('数量限制设置成功')
            this.getCustomizedCode()
        }).catch((res: any) => {
            this.$toast(res.msg)
        })
    }
    activeCode(data: any) {
        this.isShowCode = data == 1
    }
    deleteItem(item: any) {    // 删除邀请码
        this.$dialog.confirm({
            title: "删除会导致邀请码失效，确认删除吗？"
        }).then(() => {
            this.fetch({
                url: `${this.api.customizedCodeDelate}?baseId=${this.$route.params.id}&sceneId=${this.baseld}&id=${item.id}&status=10`,
                method: "POST",
            }).then((res: any) => {
                this.$toast('已删除选择的邀请码')
                this.getCustomizedCode()
            }).catch((res: any) => {
                this.$toast(res.msg)
            })
        })
    }
    copyLinkCode(item: any, num: number) {
        let copyItem = item
        if (num == 1) {
            copyItem = "直播间链接：" + item.baseUrl + '\r' + "邀请码：" + item.inviteCode
            this.$toast('已复制直播间链接+邀请码')
        } else {
            copyItem = item.inviteCode
            this.$toast('已复制邀请码')
        }
        let copyInput = document.createElement('input');//创建input元素
        document.body.appendChild(copyInput);//向页面底部追加输入框
        copyInput.setAttribute('value', copyItem);//添加属性，将url赋值给input元素的value属性
        copyInput.select();//选择input元素
        document.execCommand("Copy");//执行复制命令
        copyInput.remove();//删除动态创建的节点
    }
    clickInput(index:number) {
        this.customInviteCodeList[index].isInput = false
        this.$forceUpdate()
    }
    blurFn(item:any,index:number) {
        if(item.remark.length < 1) item.remark = null
        this.customInviteCodeList[index].isInput = true
        this.fetch({
            url: `${this.api.modifyInviteCodeRemarks}?id=${item.id}&baseId=${this.$route.params.id}&sceneId=${this.baseld}&remark=${item.remark}`,
            method: "POST",
        }).then((res: any) => {
            this.$toast('已修改备注信息')
            this.getCustomizedCode()
        }).catch((res: any) => {
            this.$toast(res.msg)
            this.$forceUpdate()
        })
        this.$forceUpdate()
    }
    addCode() {
        this.fetch({
            url: `${this.api.addCodeItem}?baseId=${this.$route.params.id}&sceneId=${this.baseld}`,
            data: {},
            method: "GET",
        }).then((res: any) => {
            this.getCustomizedCode()
            this.$toast('定制邀请码生成成功')
        }).catch((res: any) => {
            this.$toast(res.msg)
        })
    }
}